import log from "../../utils/logger/library";
import { set_right_rail } from "../../reducers/RightRail/reducer";
import { set_loading_complete } from "../Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import { fetchPageSupplementaryData } from "../../fetch/graphql/page";
import { createFeatureFlagSelector } from "../../selectors/featureFlag";
import { fetch_some_newsletters } from "../Newsletters/actions";
import { TYPE_NEWSLETTER } from "../../constants/page";

/**
 * Filter widgets by sourceId, if defined in `state.featureFlag.rightrail{ path }`.
 * Example: Migrating to a FLP page.
 * The Original Page uses `getSidebarWidgets()` to display a hard coded widget.
 * When you add the same widget to `state.rightRail` (defined in Polopoly), you'll get both widgets
 * appearing. To solve this add the sourceId to `featureFlag.rightrail{ path }`, so `getSidebarWidgets()`
 * only displays the hard coded widget, and FLP page displays the widget using `state.page`.
 */

const featureFlagSelector = createFeatureFlagSelector("rightrail");

const filterByFeatureFlag = (state, section, list) => {
    featureFlagSelector(state)
        .filter(({ path }) => path === section)
        .forEach(({ value }) => {
            const hide = value?.hide || [];
            hide.forEach((id) => {
                list = list.filter(
                    (widget) =>
                        !(
                            (widget?.sourceId || widget?.wrapper?.sourceId) ===
                            `${id}`
                        )
                );
            });
        });
    return list;
};

/**
 * Async action creator for handing fetching data for the rightrail
 *
 * @param {string} path The relative path of the landing section to fetch
 */
export function fetch_supplementary_data(path, isDetail = false) {
    return async (dispatch, getState) => {
        try {
            dispatch(start_loading());

            const { page } = await fetchPageSupplementaryData(
                `path: "${path}"`,
                isDetail
            );

            if (!page) {
                return;
            }

            const [section] = page.sections;
            //TODO: Remove ratioCustom fallback once all images have been migrated to AIS
            const bannerImage =
                page.bannerImage?.aspects?.ratio5x1?.url ||
                page.bannerImage?.aspects?.ratioCustom?.url ||
                "";

            if (!section.right?.content && !bannerImage) {
                return;
            }

            const state = getState();
            const widgets = filterByFeatureFlag(
                state,
                page.path,
                section.right?.content || []
            );

            const dispatchers = [
                dispatch(
                    set_right_rail({
                        path: page.path,
                        banner: bannerImage,
                        widgets,
                        defaultHeadlineImage:
                            page.section?.defaultHeadlineImage?.aspects
                                ?.ratio16x9?.url || "",
                    })
                ),
            ];
            const newsletters = state?.newsletters?.newsletters || null;

            if (!newsletters || newsletters === "false") {
                const newsletter = widgets
                    .map((widget) => {
                        if (widget.type === TYPE_NEWSLETTER) {
                            return widget?.pageWidget?.metadata?.newsletter;
                        }
                    })
                    .filter(Boolean);
                dispatchers.push(
                    dispatch(fetch_some_newsletters(...newsletter))
                );
            }

            return Promise.all(dispatchers);
        } catch (error) {
            log.error(
                `(fetch_supplementary_data) Path ${path} does not exist`,
                error
            );
        } finally {
            dispatch(set_loading_complete());
        }
    };
}
